import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  defaultOption: {
    defaultMessage: 'Select Danger Type',
    description: 'The default option for the dangerous goods type dropdown',
    id: '4cg9PN',
  },
  dangerousGoodsType: {
    defaultMessage: 'Dangerous Goods Type',
    description: 'The label for the dangerous goods type dropdown',
    id: 'qDBbmQ',
  },
  emergencyContact: {
    defaultMessage: 'Emergency Contact',
    description: 'The label for the emergency contact input',
    id: 'bnv7ZZ',
  },
});
